import bridge from '@didi/driver-biz-sdk/lib/bridge'
import { env } from '@didi/utils'

export function setTitle(title: string):void {
  document.title = title
  if (env.rainbow) {
    bridge.setTitle({
      navi_title: title
    })
    return
  }
  if (env.isDriver && env.isIOS) {
    bridge.setTitle({
      vctitle: title
    })
  }
  iframeTitle()
}

function iframeTitle() {
  const iframe = document.createElement('iframe')
  iframe.style.visibility = 'hidden'
  iframe.style.display = 'none'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = 'none'
  iframe.src = 'https://static.udache.com/recommend/favicon.ico'
  iframe.onload = () => {
    setTimeout(() => {
      document.body.removeChild(iframe)
    }, 0)
  }
  document.body.appendChild(iframe)
}
